import{gql as i}from"@apollo/client";const e=i`
  mutation resendActivationCode($email: String, $newEmail: String) {
    resendActivationCode(email: $email, newEmail: $newEmail)
  }
`;export{e as RESEND_ACTIVATION_CODE_MUTATION};
//# sourceMappingURL=useResendActivationCode.graphql.js.map
